import groupBy from 'lodash/groupBy';
import React from 'react';

import FlowerIcon from '@/components/icons/Flower.svg';
import LeafIcon from '@/components/icons/Leaf.svg';
import SnowflakeIcon from '@/components/icons/Snowflake.svg';
import SunIcon from '@/components/icons/Sun.svg';
import { ILocation } from '@/services/getCMSPageData';

import css from './SeasonalActivities.module.css';
interface IActivities {
  description: string;
  location: ILocation;
  season: string;
  title: string;
}

interface IProps {
  title: string;
  activities: IActivities[];
}

const sections = [
  {
    name: 'spring',
    label: 'Spring',
    icon: FlowerIcon,
  },
  {
    name: 'summer',
    label: 'Summer',
    icon: SunIcon,
  },
  {
    name: 'fall',
    label: 'Fall',
    icon: LeafIcon,
  },
  {
    name: 'winter',
    label: 'Winter',
    icon: SnowflakeIcon,
  },
  {
    name: 'in-season',
    label: 'In-Season',
    icon: SunIcon,
  },
  {
    name: 'off-season',
    label: 'Off-Season',
    icon: SnowflakeIcon,
  },
];
const renderSeason = (activities: IActivities[] | undefined) => {
  return (
    <div>
      {activities?.map(activity => {
        return (
          <div key={activity.title}>
            <h4>{activity.title}</h4>
            <div dangerouslySetInnerHTML={{ __html: activity.description }} />
          </div>
        );
      })}
    </div>
  );
};
const SeasonalActivities: React.FC<IProps> = ({ activities, title }) => {
  const seasonContent = groupBy(activities, 'season');

  return (
    <>
      <h2 className="mb-4 highlight autoType800">Seasonal activities in {title}</h2>
      {Object.keys(seasonContent).map(seasonName => {
        const section = sections.find(s => s.name === seasonName);
        return section ? (
          <div className={css.section} key={seasonName}>
            <h3 className={css.header}>
              <div className={css.icon}>
                <section.icon />
              </div>
              {section.label}
            </h3>
            {renderSeason(seasonContent[seasonName])}
          </div>
        ) : null;
      })}
    </>
  );
};

export default SeasonalActivities;
